<script setup lang="ts">
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { LoginPayload, LoginResponseInterface } from "@/types/auth";
import { useAuthStore } from "@/stores/auth";
import { ref } from "vue";
import { toast } from "vue-sonner";
import PageLoading from "@/components/Common/PageLoading.vue";

const isLoading = ref(false);
const authStore = useAuthStore();
const loginResponse = ref<LoginResponseInterface>();

const validationSchema = toTypedSchema(
  zod.object({
    email: zod.string().nonempty({ message: "Email is Required" }),
    password: zod.string().min(6).nonempty(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: email } = useField<string>("email");
const { value: password } = useField<string>("password");

const onSubmit = handleSubmit(async () => {
  isLoading.value = true;
  const payloadLogin: LoginPayload = {
    email: email.value,
    password: password.value,
  };

  const { success, message } = await authStore.dispatchLogin(payloadLogin);

  if (success == true) {
    loginResponse.value = await authStore.authResponse;
    setTimeout(() => {
      isLoading.value = false;
      toast.success("Login Successfully");
    }, 1000);
    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 1500);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});
</script>
<template>
  <PageLoading v-if="isLoading" />
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img
          src="@/assets/images/logo/logo-portrait.png"
          class="rounded-3"
          alt="login"
        />
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto mt-5">
          <h3 class="fs-28 mb-2">Welcome back to</h3>
          <h3 class="fs-28 mb-2">Ship Store Management System</h3>
          <form @submit="onSubmit" class="row g-3 needs-validation form">
            <div class="form-group mb-4">
              <label class="label text-secondary">Email Address</label>
              <input
                type="text"
                v-model="email"
                class="form-control h-55"
                placeholder="Type email"
              />
            </div>
            <div class="form-group mb-4">
              <label class="label text-secondary">Password</label>
              <input
                type="password"
                v-model="password"
                class="form-control h-55"
                placeholder="Type password"
              />
            </div>
            <div class="form-group mb-4">
              <button
                type="submit"
                class="btn btn-primary fw-medium py-2 px-3 w-100"
              >
                <div
                  class="d-flex align-items-center justify-content-center py-1"
                >
                  <i class="material-symbols-outlined text-white fs-20 me-2">
                    login
                  </i>
                  <span>Login</span>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
